import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class PaginationService {

  constructor(
    private httpClient: HttpClient
  ) { }

  public getFromUrl(url: string = '') {
    return this.httpClient.get(url);
  }
}
